export default {"src":"/_next/static/media/whatsapp.0e88ef14.svg","height":40,"width":40};